export default __webpack_public_path__ + "static/media/Advice-IMG-1.24b1c5a9.png";